import fireProtectionService from '@/services/fireProtection.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		fireProtections: [],
		listFireProtections: [],
		roundFireProtections: [],
		fireExtinguishers: [
			'Pulversläckare',
			'Skumsläckare',
			'Kolsyresläckare',
			'Vattenbrandsläckare',
			'Fettbrandsläckare',
			'AVD-Litiumbrandsläckare'
		],
		fireProtection: {},
		searchParams: {
			search: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_LISTFIREPROTECTIONS(state, fireProtections) {
			state.listFireProtections = fireProtections;
		},
		SET_FIREPROTECTIONS(state, fireProtections) {
			state.fireProtections = fireProtections;
		},
		SET_FIREPROTECTION(state, fireProtection) {
			state.fireProtection = fireProtection;
		},
		SET_ROUND_FIREPROTECTIONS(state, fireProtection) {
			state.roundFireProtections = fireProtection;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getFireProtection({ commit }, fireProtectionId) {
			return await fireProtectionService
				.getFireProtection(fireProtectionId)
				.then(data => {
					commit('SET_FIREPROTECTION', data);
				})
				.catch(err => {
					console.log('Error getting fireProtection: ', err);
				});
		},
		async getFireProtections({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });
			state.searchParams.companyId = rootGetters['user/getActiveCompany'].id;
			state.searchParams.customerId = rootGetters['user/getActiveCustomer'].id;

			return await fireProtectionService
				.getFireProtections(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_FIREPROTECTIONS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getFireProtections');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting fireProtections: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getListFireProtections({ commit, dispatch, rootGetters }, search) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				search: search,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 0
			};

			searchParams.companyId = rootGetters['user/getActiveCompany'].id;
			searchParams.customerId = rootGetters['user/getActiveCustomer'].id;

			return await fireProtectionService
				.getFireProtections(searchParams)
				.then(data => {
					commit('SET_LISTFIREPROTECTIONS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting fireProtections: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundFireProtections({ commit, dispatch }, roundPlanningId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				roundPlanningId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await fireProtectionService
				.getFireProtections(searchParams)
				.then(data => {
					commit('SET_ROUND_FIREPROTECTIONS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting fireprotections: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createFireProtection({ dispatch }, fireProtection) {
			return await fireProtectionService
				.createFireProtection(fireProtection)
				.then(() => {
					dispatch('getFireProtections');
				})
				.catch(err => {
					console.log('Error creating fireProtection: ', err);
				});
		},
		async updateFireProtection({ dispatch }, fireProtection) {
			return await fireProtectionService
				.updateFireProtection(fireProtection)
				.then(() => {
					dispatch('getFireProtections');
				})
				.catch(err => {
					console.log('Error updating fireProtection: ', err);
				});
		},
		async deleteFireProtection({ dispatch }, fireProtection) {
			return await fireProtectionService
				.deleteFireProtection(fireProtection.id)
				.then(() => {
					dispatch('getFireProtections');
				})
				.catch(err => {
					console.log('Error deleting fireProtection: ', err);
				});
		},

		setFireProtection({ commit }, fireProtection) {
			commit('SET_FIREPROTECTION', fireProtection);
		},
		setFireProtections({ commit }, fireProtections) {
			commit('SET_FIREPROTECTIONS', fireProtections);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		fireProtections: state => {
			return state.fireProtections;
		},
		listFireProtections: state => {
			return state.listFireProtections;
		},
		roundFireProtections: state => {
			return state.roundFireProtections;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
